import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Button from '~components/button';
import NotificationsActions from '~redux/notifications';
import { useAuth0 } from '@auth0/auth0-react';

import * as REST from '~services/rest';

import { ChatContext } from '../../context';

const Delete = () => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const { discussion } = useContext(ChatContext);
  const { getAccessTokenSilently } = useAuth0();

  const [isLoading, setIsLoading] = useState(false);

  const deleteChat = async () => {
    setIsLoading(true);
    try {
      const token = await getAccessTokenSilently();
      await REST.del({
        name: `chats/${discussion.discussionId}`,
        requiresAuthentication: true,
        token,
      });

      dispatch(
        NotificationsActions.addNotification(
          intl.formatMessage({
            id: `containers.chat.options.delete.notification`,
            defaultMessage: 'Chat has been deleted',
          })
        )
      );

      history.push('/chats');
    } catch (err) {
      console.log(`Error while performing deleting chat`, err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      disabled={
        !discussion || !discussion.discussionId || isLoading
      }
      onClick={deleteChat}
      isLoading={isLoading}
      className="c-vertical-nav__item c-btn--text c-btn--show-text-with-loader"
      role="menuitem"
    >
      {intl.formatMessage({
        id: 'containers.chat.options.delete.label',
        defaultMessage: 'Delete chat',
      })}
    </Button>
  );
};

export default Delete;
